import { render, staticRenderFns } from "./registration_temp.html?vue&type=template&id=5ff3d17f&scoped=true&external"
import script from "./registration_temp.vue?vue&type=script&lang=js"
export * from "./registration_temp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3d17f",
  null
  
)

export default component.exports